import { Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IAvailableServicesSectionProps {
  children: React.ReactNode;
}

export const AvailableServicesSection: React.FC<IAvailableServicesSectionProps> = ({
  children,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Flex flexDir="column" gap={8}>
      <Heading
        as="h1"
        fontSize={{ base: 'h3.base', md: 'h3.md' }}
        fontWeight="bold"
        textAlign="left"
      >
        {t('QUOTE_DETAILS.ADD_SERVICES_LABEL')}
      </Heading>
      {children}
    </Flex>
  );
};
